import { Factory } from 'miragejs'
const faker = require('faker');
import { randomPartnerCampaigns } from '../utils'

const randomRewardedUserValue = faker.datatype.number({ min: 1, max: 10 }) * 100


export default {
  campaign: Factory.extend({
    id() {
      return faker.datatype.uuid()
    },
    title() {
      return faker.company.companyName()
    },
    description() {
      return faker.commerce.productDescription()
    },
    image() {
      return faker.image.imageUrl()
    },
    value() {
      return faker.datatype.number({ max: 10 })
    }
  }),
  partner: Factory.extend({
    id() {
      return faker.datatype.uuid()
    },
    color() {
      return faker.internet.color()
    },
    logo() {
      return faker.image.business()
    },
    logo_negative() {
      return faker.image.business()
    },
    name() {
      return faker.company.companyName()
    },
    slug() {
      return faker.datatype.uuid()
    },
    description() {
      return faker.commerce.productDescription()
    },
    campaigns() {
      return randomPartnerCampaigns()
    }
  }),
  coin: Factory.extend({
    id() {
      return faker.datatype.uuid()
    },
    program_name() {
      return faker.fake('{{name.findName}}')
    },
    program_image() {
      return faker.image.imageUrl()
    },
    balance() {
      return faker.datatype.number({ max: 100 })
    }
  })

}



// WEBPACK FOOTER //
// ./src/mocks/factories/index.js